export default "__VITE_ASSET__STS4iu6u__"